import { AlertTriangle, Check, X, Siren } from "lucide-react";
import { Button } from "../components/ui/button";
import { IDS } from "../constants/testIds";

export default function EmergencyAlerts({ alerts, onAck, onDismiss, onTriggerSOS, canTrigger }) {
  const active = alerts.filter(a => !a.acknowledged);
  return (
    <div data-testid={IDS.alerts.root} className="h-full rounded-xl border border-slate-200 bg-white overflow-hidden flex flex-col">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between flex-shrink-0">
        <div className="flex items-center gap-2">
          <AlertTriangle className={`h-4 w-4 ${active.length ? "text-red-600" : "text-slate-400"}`} />
          <div>
            <div className="overline">Emergencies</div>
            <h3 className="text-sm font-semibold">{active.length ? `${active.length} active` : "All clear"}</h3>
          </div>
        </div>
        <Button
          data-testid={IDS.alerts.trigger}
          variant="outline" size="sm"
          className="gap-1.5 border-red-200 text-red-700 hover:bg-red-50"
          onClick={onTriggerSOS} disabled={!canTrigger}
        >
          <Siren className="h-3.5 w-3.5" /> Test SOS
        </Button>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto thin-scroll">
        {alerts.length === 0 && (
          <div className="p-6 text-center text-xs text-slate-400">No alerts.</div>
        )}
        {alerts.slice(0, 50).map(a => (
          <div
            key={a.id}
            data-testid={IDS.alerts.item(a.id)}
            className={`px-4 py-2.5 border-b border-slate-50 flex items-center gap-2 ${a.acknowledged ? "opacity-50" : ""}`}
          >
            <span className={`dot ${a.acknowledged ? "offline" : "sos"}`} />
            <div className="min-w-0 flex-1">
              <div className="text-xs font-semibold truncate">{a.contact_name}</div>
              <div className="text-[11px] text-slate-500 truncate">{a.message}</div>
            </div>
            {!a.acknowledged && (
              <button
                data-testid={IDS.alerts.ack(a.id)}
                onClick={() => onAck(a.id)}
                className="text-emerald-700 hover:bg-emerald-50 p-1 rounded"
                aria-label="Acknowledge"
              >
                <Check className="h-4 w-4" />
              </button>
            )}
            <button onClick={() => onDismiss(a.id)} className="text-slate-400 hover:text-red-600 p-1 rounded" aria-label="Dismiss">
              <X className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
